import React from 'react';
import unstop from './assets/unstop.png';
import Saturn from './assets/Saturn.png';
import topLeftG1 from './assets/top-left-g-1.png';
import topLeftG2 from './assets/top-left-g-2.png';
import topRightG1 from './assets/top-right-g1.png';
import bottomRight from './assets/bottom-right.svg';
import './css/Experience.css';

const experiences = [
  {
    id: 'unstop',
    designation: 'Senior Frontend Engineer',
    org: 'Unstop',
    location: 'New Delhi',
    time: 'Oct 2023 – Mar 2026',
    accentColor: '#4a6fa5',
    highlights: [
      'Re-architected high-traffic opportunity module (25M+ users) — Lighthouse score 35% → 85%+ via code splitting, lazy loading & Core Web Vitals optimisation',
      'Built & published reusable Interview Library as an internal npm package using the Strategy Pattern; integrated socket-based real-time toolkit with role-based access control',
      'Designed config-based nudge engine (API-driven UI), increasing user engagement by 20% and eliminating hardcoded frontend logic',
      'Developed dynamic email templates with backend-driven schemas; built AMP pages and Blade templates to improve SEO & page performance',
      'Led 2 junior engineers, conducted code reviews, drove cross-functional Agile delivery with product, backend & design teams',
    ],
    stack: ['Angular', 'React', 'TypeScript', 'RxJS', 'Node.js', 'Laravel', 'REST APIs', 'SSR', 'AMP'],
    logo: unstop,
    logoLink: 'https://unstop.com/',
  },
  {
    id: 'akal',
    designation: 'Software Developer',
    org: 'Akal Information Systems Ltd',
    location: 'New Delhi',
    time: 'Aug 2022 – Oct 2023',
    accentColor: '#6a9e8f',
    highlights: [
      'Refactored product classification & drill-down reporting modules (ASP.NET, SQL Server), enhancing query performance and data accessibility',
      'Automated flat-file ingestion pipelines with SSIS, streamlining ETL workflows and eliminating manual processing overhead',
      'Built Node.js REST APIs for dynamic contract job filtering, improving admin dashboard performance and usability',
      'Contributed across full SDLC — requirements analysis, implementation, testing & production support',
    ],
    stack: ['ASP.NET', 'SQL Server', 'Angular', 'JavaScript', 'REST APIs', 'SSIS', 'Node.js'],
    logo: null,
    logoLink: null,
  },
  {
    id: 'hybrowlabs',
    designation: 'React Developer',
    org: 'Hybrowlabs Technologies',
    location: 'Remote',
    time: 'Apr 2022 – Aug 2022',
    accentColor: '#c4924a',
    highlights: [
      'Developed modular React components for CMS-driven applications using GraphCMS & RESTful APIs',
    ],
    stack: ['React', 'JavaScript', 'REST API', 'GraphCMS'],
    logo: null,
    logoLink: null,
  },
  {
    id: 'doubtconnect',
    designation: 'Web Developer',
    org: 'DoubtConnect',
    location: 'Remote',
    time: 'Jan 2021 – Jun 2021',
    accentColor: '#c9a84c',
    highlights: [
      'Constructed and maintained full-stack features including differential login/signup functionality',
      'Integrated Firebase for database handling, authentication & state management',
    ],
    stack: ['React', 'JavaScript', 'Express', 'Node.js', 'Firebase', 'HTML'],
    logo: null,
    logoLink: null,
  },
];

const Experience = () => {
  return (
    <>


      <div className="experience" id="experience">

        {/* ── Decorative corners (unchanged) ── */}
        <div className="top-left">
          <img src={topLeftG1} alt="" className="top-left-g1" />
          <img src={topLeftG2} alt="" className="top-left-g2" />
        </div>
        <div className="top-right">
          <img src={topRightG1} alt="" className="top-right-g1" />
        </div>
        <div className="funnel">
          <img src={Saturn} alt="" className="saturn" />
        </div>

        <h3>Experience</h3>

        {/* ── Timeline Cards ── */}
        <div className="exp-timeline">
          {experiences.map((exp, i) => {
            const side = i % 2 === 0 ? 'left' : 'right';
            const rgb = hexToRgb(exp.accentColor);

            return (
              <div className={`exp-row ${side}`} key={exp.id}>

                {/* timeline dot */}
                <div
                  className="exp-dot"
                  style={{ borderColor: exp.accentColor, color: exp.accentColor }}
                />

                {/* card */}
                <div className="exp-card-slot">
                  <div
                    className="exp-crd"
                    style={{
                      '--crd-accent': exp.accentColor,
                      '--crd-glow': `${exp.accentColor}33`,
                      '--crd-accent-rgb': rgb,
                    }}
                  >
                    <div className="inner">
                      <p className="time-line">{exp.time}</p>
                      <h4 className="designation">{exp.designation}</h4>
                      <h3 className="org-name">{exp.org}</h3>

                      <div className="meta">
                        <span className="location-badge">{exp.location}</span>
                      </div>

                      <ul className="highlights">
                        {exp.highlights.map((h, j) => (
                          <li key={j}>{h}</li>
                        ))}
                      </ul>

                      <div className="stack-row">
                        {exp.stack.map((s, j) => (
                          <span key={j} className="stack-pill">{s}</span>
                        ))}
                      </div>

                      {exp.logo && (
                        <a href={exp.logoLink} target="_blank" rel="noreferrer">
                          <img src={exp.logo} alt={exp.org} className="org-logo" />
                        </a>
                      )}
                    </div>
                  </div>
                </div>

                <div className="exp-spacer" />
              </div>
            );
          })}
        </div>

        {/* ── Bottom bar (unchanged) ── */}
        <div className="bottom-left">
          <div className="green-txt d-flex flex-column">
            <span>-</span><span>-</span><span>-</span><span>-</span>
          </div>
          <div className="blue-txt">
            <div className="d-flex gap-10p">
              <div className="d-flex gap-5p"><span>^G </span> Help</div>
              <div className="d-flex gap-5p"><span>^O </span> Write Out</div>
              <div className="d-flex gap-5p"><span>^W </span> Where Is</div>
            </div>
            <div className="d-flex gap-10p">
              <div className="d-flex gap-5p"><span>^X </span> Exit</div>
              <div className="d-flex gap-5p"><span>^R </span> Read File</div>
              <div className="d-flex gap-5p"><span>^W </span> Paste</div>
            </div>
          </div>
        </div>

        <div className="bottom-right">
          <img src={bottomRight} alt="" />
        </div>

        {/* ── warn-term — updated copy since dragging is gone ── */}
        {/* <div className="warn-term">
                    <div>------------------------------</div>
                    <div>⚠️ ALERTS</div>
                    <div>------------------------------</div>
                    <div className="yellow">
                        WARNING: These cards are static. No dragging allowed.
                    </div>
                    <div>------------------------------</div>
                    <div>CURRENT SETTINGS</div>
                    <div className="d-flex flex-column gap-5p">
                        - Server Listening at: <span>http://localhost:3000</span>
                        - Log level: <span>debug</span>
                        - Watch enabled: <span>true</span>
                    </div>
                </div> */}

      </div>
    </>
  );
};

function hexToRgb(hex) {
  const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!r) return '255,255,255';
  return `${parseInt(r[1], 16)},${parseInt(r[2], 16)},${parseInt(r[3], 16)}`;
}

export default Experience;